import { createSlice } from '@reduxjs/toolkit';
export const callRecordingSlice = createSlice({
    name: 'callRecording',
    initialState: {
        byId: {},
    },
    reducers: {
        setCallRecording: (state, action) => {
            const { callId, recordingUrl } = action.payload;
            state.byId[callId] = recordingUrl;
        },
        resetCallRecording: (state) => {
            state.byId = {};
        },

    },
});

export const { setCallRecording, resetCallRecording } = callRecordingSlice.actions;
//Selectors
export const selectCallRecording = (state, callId) => state.callRecording.byId[callId];
export default callRecordingSlice.reducer;